import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Coins, Share2, BarChart3, CalendarClock } from "lucide-react";
import { Button } from "../components/ui/button";

export default function Affiliates() {
  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20" data-testid="affiliates-page">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="max-w-3xl">
        <span className="eyebrow">Partner Program</span>
        <h1 className="font-display tracking-tighter text-5xl sm:text-6xl mt-4 leading-[1.05]">
          Earn <span className="text-brand">20%</span> recurring on every license you secure.
        </h1>
        <p className="text-lg text-slate-300 mt-6 leading-relaxed">
          For elite coaches, consultants, and corporate wellness providers. Recommend the gold standard in health auditing and build a recurring revenue stream.
        </p>
      </motion.div>

      <div className="mt-16 grid grid-cols-1 md:grid-cols-4 gap-4">
        {[
          { icon: <Share2 className="w-5 h-5" />, t: "Secure Referral Tracking", b: "Unique tracking links for your proposals, decks, and digital ecosystem." },
          { icon: <Coins className="w-5 h-5" />, t: "20% Recurring Payouts", b: "Earn on every renewal. High-margin returns for both Gym and Business licenses." },
          { icon: <BarChart3 className="w-5 h-5" />, t: "Partner Dashboard", b: "Real-time visibility into attribution, conversions, and lifetime earnings." },
          { icon: <CalendarClock className="w-5 h-5" />, t: "Monthly Settlements", b: "Automated payouts via Stripe Express on the 1st of every month." },
        ].map((p, idx) => (
          <div key={p.t} className="glass rounded-2xl p-6" data-testid={`affiliate-point-${idx}`}>
            <div className="w-10 h-10 grid place-items-center rounded-lg bg-white/5 border border-white/10 text-brand mb-5">
              {p.icon}
            </div>
            <h3 className="font-display text-lg mb-2">{p.t}</h3>
            <p className="text-sm text-slate-400 leading-relaxed">{p.b}</p>
          </div>
        ))}
      </div>

      <div className="mt-12 flex flex-wrap gap-3">
        {/* WE CHANGE THE LINK FROM /REGISTER TO /CONTACT */}
        <Link to="/contact">
          <Button className="btn-glow rounded-full h-12 px-7" data-testid="affiliate-signup">
            Apply to become a partner
          </Button>
        </Link>
        <Link to="/login">
          <Button className="btn-ghost-bordered rounded-full h-12 px-7" data-testid="affiliate-login">
            Partner Login
          </Button>
        </Link>
      </div>
    </div>
  );
}
